$('.filter span').click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $('.showcase').removeClass('show-showcase');
    } else {
        $(this).addClass('active');
        $('.showcase').addClass('show-showcase');
    }
});

$('.search').click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $('.full-research').removeClass('show-showcase');
    } else {
        $(this).addClass('active');
        $('.full-research').addClass('show-showcase');
    }
});
$('.sho-result').click(function () {
    $('.search').removeClass('active');
    $('.full-research').removeClass('show-showcase');
    $('html, body').animate({scrollTop: $('#main-page-premise-pages').offset().top}, 'slow');
    return false;
});




// WEBPACK FOOTER //
// ./resources/js/snippets/catalog.js